import { ProductFilterFormData } from "entities/products/types/ProductFilter"
import { map } from "nanostores"

const defaultState: Record<string, ProductFilterFormData> = {}

// Deliberately not persisted, see portfolio-filter-store.
export const productCategoryFilterStore =
  map<Record<string, ProductFilterFormData>>(defaultState)

export function setFilterState(
  productCategoryID: string,
  state: ProductFilterFormData
) {
  productCategoryFilterStore.setKey(productCategoryID, state)
}

export function resetFilterState() {
  productCategoryFilterStore.set(defaultState)
}
